/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetNaicsCode_naicsCodes_NaicsRecord = { readonly __typename: 'NaicsRecord', readonly naicsCode: string | null, readonly title: string | null };

export type GetNaicsCode_Query = { readonly __typename: 'Query', readonly naicsCodes: ReadonlyArray<GetNaicsCode_naicsCodes_NaicsRecord> | null };


export type GetNaicsCodeVariables = _Types.Exact<{
  query: _Types.Scalars['String']['input'];
}>;


export type GetNaicsCode = GetNaicsCode_Query;


export const GetNaicsCodeDocument = gql`
    query GetNaicsCode($query: String!) {
  naicsCodes(query: $query) {
    naicsCode
    title
  }
}
    `;

/**
 * __useGetNaicsCode__
 *
 * To run a query within a React component, call `useGetNaicsCode` and pass it any options that fit your needs.
 * When your component renders, `useGetNaicsCode` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNaicsCode({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetNaicsCode(baseOptions: Apollo.QueryHookOptions<GetNaicsCode, GetNaicsCodeVariables> & ({ variables: GetNaicsCodeVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNaicsCode, GetNaicsCodeVariables>(GetNaicsCodeDocument, options);
      }
export function useGetNaicsCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNaicsCode, GetNaicsCodeVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNaicsCode, GetNaicsCodeVariables>(GetNaicsCodeDocument, options);
        }
export function useGetNaicsCodeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNaicsCode, GetNaicsCodeVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNaicsCode, GetNaicsCodeVariables>(GetNaicsCodeDocument, options);
        }
export type GetNaicsCodeHookResult = ReturnType<typeof useGetNaicsCode>;
export type GetNaicsCodeLazyQueryHookResult = ReturnType<typeof useGetNaicsCodeLazyQuery>;
export type GetNaicsCodeSuspenseQueryHookResult = ReturnType<typeof useGetNaicsCodeSuspenseQuery>;
export type GetNaicsCodeQueryResult = Apollo.QueryResult<GetNaicsCode, GetNaicsCodeVariables>;